import React, { useState, useEffect } from 'react';
import {
  Container, Box, Paper, Typography, TextField,
  Button, IconButton, InputAdornment, Fade
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import '../styles/styles.css';

const ResetPassword = ({ notificationsRef }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tokenValid, setTokenValid] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) setTokenValid(false);
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword) { notificationsRef.current.showSnackbar('Enter a new password.', 'error'); return; }
    if (newPassword !== confirmPassword) { notificationsRef.current.showSnackbar("Passwords don't match.", 'error'); return; }

    setLoading(true);
    try {
      await api.resetPassword({ token, new_password: newPassword });
      notificationsRef.current.showSnackbar('Password updated!', 'success');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      notificationsRef.current.showSnackbar(err.message, 'error');
      setLoading(false);
    }
  };

  if (!tokenValid) {
    return (
      <Box className="resetContainer">
        <Container component="main" maxWidth="xs" className="resetMainContainer">
          <Paper elevation={0} className="resetPaper">
            <Typography component="h1" className="resetTitle">Invalid link</Typography>
            <Typography variant="body2" color="text.secondary" align="center" mt={1}>
              This reset link is invalid or has expired.
            </Typography>
            <Button variant="contained" onClick={() => navigate('/forgot-password')} sx={{ mt: 3, borderRadius: '10px', textTransform: 'none', fontWeight: 500, boxShadow: 'none' }}>
              Request new link
            </Button>
          </Paper>
        </Container>
      </Box>
    );
  }

  return (
    <Box className="resetContainer">
      <Container component="main" maxWidth="xs" className="resetMainContainer">
        <Fade in={true} timeout={600}>
          <Paper elevation={0} className="resetPaper">
            <Box className="safeHeader" style={{ marginBottom: 24 }}>
              <Typography component="h1" className="resetTitle">New Password</Typography>
              <Typography variant="body2" color="text.secondary" align="center">
                Choose a strong password
              </Typography>
            </Box>
            <form onSubmit={handleSubmit} noValidate style={{ width: '100%' }}>
              <TextField
                required fullWidth margin="normal" label="New Password"
                type={showPassword ? 'text' : 'password'} autoFocus
                value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(p => !p)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                required fullWidth margin="normal" label="Confirm Password"
                type={showPassword ? 'text' : 'password'}
                value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(p => !p)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <Button type="submit" fullWidth variant="contained" className="resetSubmitButton" disabled={loading}>
                {loading ? 'Updating...' : 'Update Password'}
              </Button>
            </form>
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default ResetPassword;